module.exports = __webpack_public_path__ + "static/media/location-icon-white.93a3965c.svg";